// @flow

import "./upselling_item_descriptor.css";
import "./toolbar.css";

import * as React from "react";
import { Button } from "react-bootstrap";

import * as Catalogue from "models/catalogue";
import OrderItem from "models/order_item";

const UpsellingItemDescriptor = ({
  orderItem,
  onUpdate
}: {
  orderItem: OrderItem,
  onUpdate: OrderItem => void
}) => {
  let { product, size } = orderItem;

  return (
    <div className={`order-details--upselling-item`}>
      <img
        className="order-details--upselling-item--product-image"
        alt={Catalogue.get_product_name(product)}
        src={Catalogue.get_product_cover_image_url(product)}
      />
      <span className={"order-details--upselling-item--product-name"}>
        {Catalogue.get_product_attr(product, "name")}
      </span>
      <span className={"order-details--upselling-item--product-size"}>
        {Catalogue.fmt_size(product, size)}
      </span>
      <div className="order-details--upselling-item--price">
        {orderItem.subtotal}
      </div>
      <Button
        className={"btn-control btn-control_highlighted"}
        onClick={() => {
          orderItem.quantity = 1;
          onUpdate(orderItem);
        }}>
        Add to cart
      </Button>
    </div>
  );
};

export default UpsellingItemDescriptor;
